import { useTranslation } from 'react-i18next';
import { KizenTypography } from '__app/typography';

export const VariableWarning = () => {
  const { t } = useTranslation();

  return (
    <KizenTypography fontStyle="italic" color="var(--color-viz-cat-7-primary)">
      <br />*
      {t(
        'One or more filters use agentic workflow variables. Blank values are compared according to their filter logic and may produce unexpected results or pause the agentic workflow in error if malformed. Please review the filter warnings, if present, to verify logic.'
      )}
    </KizenTypography>
  );
};
